export default {
	messages: {
		maxSize: 'Taille max. : {maxSizeReadable}.',
		accept: 'Format accepté : {extensions} | Formats acceptés : {extensions}'
	},
	errors: {
		MULTIPLE_FILES_SELECTED: 'Vous ne pouvez sélectionner qu’un seul fichier.',
		FILE_TOO_LARGE: 'Le fichier sélectionné est trop volumineux.',
		FILE_EXTENSION_NOT_ALLOWED: 'L’extension du fichier sélectionné n’est pas autorisée.'
	}
};
